module.exports = __webpack_public_path__ + "img/hzm-active.6376db56.png";